/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ClassroomdisciplineSharedClassStudentsQueryResponse,
  GetApiV1ClassroomdisciplineSharedClassStudentsQueryParams,
  GetApiV1ClassroomdisciplineSharedClassStudents401,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedClassStudents.ts";

function getGetApiV1ClassroomdisciplineSharedClassStudentsUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/classroomdiscipline/shared/class-students` as const,
  };
  return res;
}

/**
 * @description  **(Requer Authorization para autenticação)**
 * @summary Lookup de turmas (opcionalmente filtradas por courseId) (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/shared/class-students}
 */
export async function getApiV1ClassroomdisciplineSharedClassStudents(
  params?: GetApiV1ClassroomdisciplineSharedClassStudentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ClassroomdisciplineSharedClassStudentsQueryResponse,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedClassStudents401>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ClassroomdisciplineSharedClassStudentsUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
